import { render, staticRenderFns } from "./newbanner.vue?vue&type=template&id=0f15b46f&scoped=true"
import script from "./newbanner.vue?vue&type=script&lang=js"
export * from "./newbanner.vue?vue&type=script&lang=js"
import style0 from "./newbanner.vue?vue&type=style&index=0&id=0f15b46f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f15b46f",
  null
  
)

export default component.exports